import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';
import { debounceTime, fromEvent } from 'rxjs';
import { isMobile } from '../../../../../classes/common/helpers';
import { BackgropComponent } from '../../../../ui/base/backgrop/backgrop.component';
import { GameUiService } from '../../../../../services/game-ui/game-ui.service';
import { ResultModalWithActionsComponent } from '../../../../ui/base/result-modal-with-actions/result-modal-with-actions.component';
import { AudioService } from '../../../../../services/audio/audio.service';
import { CenterTextParam } from '../../../../ui/base/center-text/center-text.component';

interface GameCard {
  card: number;
  open: boolean;
  finded: boolean;
}

@Component({
  selector: 'app-find-a-pair',
  templateUrl: './find-a-pair.component.html',
  styleUrl: './find-a-pair.component.scss'
})
export class FindAPairComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output()
  finishGame: EventEmitter<boolean> = new EventEmitter();
  loading = true;

  cards: GameCard[];

  firstCard: GameCard | null;

  timeOut: any;

  showGameContainer = false;

  itemW = 0;
  itemH = 0;
  containerW = 0;

  showResult = false;
  disabled = true;

  skipClickedSub;

  showCenterText = false;
  
  showCenterTextParam: CenterTextParam[] = [
    {
      text: 'Старт',
      duration: 1000,
    },
  ];
  completedFn;
  constructor(
    private cdr: ChangeDetectorRef,
    private ui: GameUiService,
    private sound: AudioService,
  ) {}

  ngOnInit(): void {
    this.start();
    this.skipClickedSub = this.ui.skipClicked$.pipe(debounceTime(300)).subscribe(() => {
      this.finishGame.emit(false);
    });
  }


  ngAfterViewInit(): void {
    this.onResize();
    fromEvent(window, 'resize').subscribe(() => {
      this.onResize();
    });

  }

  ngOnDestroy(): void {
    if (this.skipClickedSub) {
      this.skipClickedSub.unsubscribe();
    }
  }

  playOpenCard() {
    this.sound.playSfx('witch_card', {volume: 1.2});
  }

  playClosedCard() {
    this.sound.playSfx('cards_closed', {volume: 1.2});
  }
  
  playCardCorrects() {
    this.sound.playSfx('card_correct', {volume: 1.2});
  }
  start() {
    this.cards = [];
    const totalCount = isMobile() ? 8 : 10;
    for (let i = 1; i <= totalCount; i++) {
      const card = {
        card: i,
        open: false,
        finded: false,
      };
      this.cards.push({...card});
      this.cards.push({...card});

      this.shuffle(this.cards);

      setTimeout(() => {
        this.loading = false;
        this.showGame();
        this.cdr.detectChanges();
      }, 500);
      setTimeout(() => {
        this.completedFn = () => {
          this.showCenterText = false;
          this.cdr.detectChanges();
        };
        this.showCenterText = true;
      }, 550);
    }
  }

  onResize() {
    if (window.innerWidth > 1024 && !isMobile()) {
      this.itemH = (window.innerHeight - 50 - 4*15) / 4;
      this.itemW = this.itemH/1.5;
      this.containerW = this.itemW*5 + 20*5;
    } else {
      this.itemH = 0;
      this.itemW = 0;
      this.containerW = 0;
    }
    this.cdr.detectChanges();
  }

  showGame() {
    this.showGameContainer = true;
    setTimeout(() => {
      this.disabled = false;
      this.cdr.detectChanges();
    }, 1000);
    this.cdr.detectChanges();
  }
  shuffle(array: GameCard[]) {
    array.sort(() => Math.random() - 0.5);
  }

  openCard(item: GameCard) {
    if (this.timeOut || item.open || item.finded || this.disabled) return;
    item.open = true;
    if (!this.firstCard) {
      this.firstCard = item;
    } else {
      this.checkDouble(item);
    }
    this.cdr.detectChanges();
  }

  checkDouble(item: GameCard) {
    if (this.firstCard?.card === item.card) {
      this.firstCard.finded = true;
      this.firstCard.open = false;
      item.finded = true;
      item.open = false;
      this.firstCard = null;
      this.checkGameOver();
      this.playCardCorrects();
      this.cdr.detectChanges();
    } else {
      this.timeOut = setTimeout(() => {
        this.playClosedCard();
        if (this.firstCard) this.firstCard.open = false;
        item.open = false;
        this.firstCard = null;
        this.timeOut = null;
        this.cdr.detectChanges();
      }, 500);
    }
  }

  checkGameOver() {
    let result = true;
    this.cards.forEach(el => {
      if (!el.finded) result = false;
    });

    if (result) {
      this.showResult = true;
      this.cdr.detectChanges();
    }
  }
  reset() {
    this.showResult = false;
    this.start();
  }

  close(success: boolean) {
    this.finishGame.emit(success);
  }
}
